import React, { useMemo } from "react";
import "./QuestionGridNumber.css";
import useAppHooks from "../../../../shared/hooks/useAppHooks";

export default function QuestionGridNumber({ selectedIndex, onSelect }) {
  const { selector } = useAppHooks();
  const { questionsData } = selector((s) => s.examSlice);
  const { practiceSolution } = selector((s) => s.analyticsSlice);

  const analyticsData = practiceSolution?.data || [];

  const data = questionsData.map((q) => {
    const analyticsQ = analyticsData.find(
      (a) => String(a.qid) === String(q.qid)
    );

    return {
      ...q,
      is_correct: analyticsQ?.is_correct,
      correct: analyticsQ?.correct,
    };
  });

  // Group data by subject & section
  const groupedData = useMemo(() => {
    if (!data.length) return [];
    const sections = [];
    let currentSection = null;
    data.forEach((q) => {
      const key = `${q.subject || "Unknown"} - ${q.section_name || "Section"}`;
      if (
        !currentSection ||
        currentSection.key !== key ||
        q.display_number === 1
      ) {
        currentSection = {
          key,
          subject: q.subject,
          section_name: q.section_name,
          questions: [],
        };
        sections.push(currentSection);
      }
      currentSection.questions.push(q);
    });
    return sections;
  }, [data]);


  const statusCounts = useMemo(() => {
  const counts = {
    correct: 0,
    incorrect: 0,
    unattempted: 0,
    marked: 0,
  };

  data.forEach((q) => {
    const attempted =
      (q.selectedOption !== null && q.selectedOption !== undefined) ||
      (q.integerAnswer && String(q.integerAnswer).trim() !== "");

    if (q.marked) {
      counts.marked++;
    } else if (!attempted) {
      counts.unattempted++;
    } else {
      let isCorrect = false;

      if (q.option && Array.isArray(q.option)) {
        q.option.forEach((opt) => {
          if (
            String(opt.option_id) === String(q.selectedOption) &&
            opt.is_correct === 1
          ) {
            isCorrect = true;
          }
        });
      }

      isCorrect ? counts.correct++ : counts.incorrect++;
    }
  });

  return counts;
}, [data]);

  if (!data.length)
    return <p style={{ textAlign: "center" }}>No questions found</p>;

  let globalIndex = 0;

//   const getClass = (q, globalI) => {
//   const isSelected = globalI === selectedIndex;

//   if (isSelected) return "selected";
//   if (q.marked) return "marked";

//   const attempted =
//     (q.selectedOption !== null && q.selectedOption !== undefined) ||
//     (q.integerAnswer && String(q.integerAnswer).trim() !== "");

//   if (!attempted) return "unattempted";

//   let isCorrect = false;

//   if (q.option && Array.isArray(q.option)) {
//     q.option.forEach((opt) => {
//       if (
//         String(opt.option_id) === String(q.selectedOption) &&
//         opt.is_correct === 1
//       ) {
//         isCorrect = true;
//       }
//     });
//   }

//   return isCorrect ? "correct" : "incorrect";
// };

  const getClass = (q) => {
  if (q.marked) return "marked";

  const attempted =
    (q.selectedOption !== null && q.selectedOption !== undefined) ||
    (q.integerAnswer && String(q.integerAnswer).trim() !== "");

  if (!attempted) return "unattempted";

  let isCorrect = false;

  if (q.option && Array.isArray(q.option)) {
    q.option.forEach((opt) => {
      if (
        String(opt.option_id) === String(q.selectedOption) &&
        opt.is_correct === 1
      ) {
        isCorrect = true;
      }
    });
  }

  return isCorrect ? "correct" : "incorrect";
};

  return (
    <div className="questionGrid_wrapper">
      <h4 className="grid_heading">Your Response Grid</h4>
       <h4 className="grid_overview">overview</h4>

      {/* Status Legend with Counts Inside Circles */}
      <div className="overview">
        <div className="status_row">
          <span className="status_circle correct">{statusCounts.correct}</span>
          Correct
        </div>
        <div className="status_row">
          <span className="status_circle incorrect">{statusCounts.incorrect}</span>
          Incorrect
        </div>
        <div className="status_row">
          <span className="status_circle unattempted">{statusCounts.unattempted}</span>
          Unattempted
        </div>
        <div className="status_row">
          <span className="status_circle marked">{statusCounts.marked}</span>
          Marked for Review
        </div>
      </div>

      {/* Sections and Questions */}
      {groupedData.map((section, sectionIndex) => (
        <div key={sectionIndex} className="section_wrapper">
          <h5>
            {section.subject} {section.section_name}
          </h5>
          <div className="grid">
            {section.questions.map((q) => {
              
              const index = globalIndex++;
              const className = getClass(q, index);

              const questionNumber =index+1; 
              return (
                <div
                  key={index}
                  className={`grid_item ${className}`}
                  onClick={() => onSelect(index)}
                  title={`Q${questionNumber}`}
                >
                  {questionNumber}
                </div>
              );
            })}
          </div>
        </div>
      ))}
    </div>
  );
}